/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktopblockmessage2Inputs */



/**
* | output |
* | --- |
* | "Luni Monster isn’t adapted to work on a computer / in a browser." |
*
* @param {Desktopblockmessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const desktopblockmessage2 = /** @type {((inputs?: Desktopblockmessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktopblockmessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Luni Monster isn’t adapted\nto work on a computer /\nin a browser.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Luni Monster no está adaptado\npara funcionar en un ordenador /\nen un navegador.")
	return /** @type {LocalizedString} */ ("Luni Monster не адаптирован\nдля работы на компьютере /\nв браузере.")
});
export { desktopblockmessage2 as "desktopBlockMessage" }